import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { ProjectSettingAction, InitAction } from "../actions";
import * as projectSettingApi from "../api/projectSetting";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
import { SetMessage } from "../assets/errorMessages";
import { goBack } from "connected-react-router";

export function* watcherProjectSetting() {
  yield takeLatest(
    types.GET_PROJECT_SOFTWARE_SETTING_REQUEST,
    getSoftwareSetting
  );
  yield takeLatest(
    types.PROJECT_SOFTWARE_SETTING_STORE_REQUEST,
    softwareSettingStore
  );
  yield takeLatest(
    types.PROJECT_TRANSACTION_FORM_SETTING_STORE_REQUEST,
    transactionFormSettingStore
  );
  yield takeLatest(
    types.PROJECT_PAYMENT_VALIDATION_SETTING_STORE_REQUEST,
    paymentValidationSettingStore
  );
  yield takeLatest(
    types.PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_REQUEST,
    accountingSoftwareWorker
  );
  yield takeLatest(
    types.PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_REQUEST,
    accountingSubSoftwareWorker
  );

  yield takeLatest(types.SHARED_CONTACTS_REQUEST, sharedContactsWorker);
  yield takeLatest(types.SET_USER_STATE_REQUEST, setUserStateWorker);
  yield takeLatest(types.SHOW_USER_REQUEST, showUserWorker);
  yield takeLatest(types.UPDATE_USER_REQUEST, updateUserWorker);
}

function getSoftwareSettingRequest() {
  return projectSettingApi.getSoftwareSetting();
}
function* getSoftwareSetting() {
  try {
    const response = yield call(getSoftwareSettingRequest);
    yield put(ProjectSettingAction.getSoftwareSettingSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.getSoftwareSettingFailure(message));
  }
}

function softwareSettingStoreRequest(data) {
  return projectSettingApi.softwareSettingStore(data);
}

function* softwareSettingStore(action) {
  try {
    const response = yield call(softwareSettingStoreRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(
      InitAction.getSuccess({ projectSetting: response.data.accounting_codes })
    );
    yield put(ProjectSettingAction.softwareSettingStoreSuccess(response.data));
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectSettingAction.softwareSettingStoreFailure());
  }
}

function fetchTransactionFormSetting(data) {
  return projectSettingApi.transactionFormSettingStore(data);
}

function* transactionFormSettingStore(action) {
  try {
    const response = yield call(fetchTransactionFormSetting, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.getSuccess({ formSetting: response.data.data }));
    yield put(ProjectSettingAction.transactionFormSettingStoreSuccess());
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectSettingAction.transactionFormSettingStoreFailure());
  }
}

function fetchPaymentValidationSetting(data) {
  return projectSettingApi.paymentValidationSettingStore(data);
}

function* paymentValidationSettingStore(action) {
  try {
    const response = yield call(fetchPaymentValidationSetting, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(
      InitAction.getSuccess({ formValidationSetting: response.data.data })
    );
    yield put(ProjectSettingAction.paymentValidationSettingStoreSuccess());
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectSettingAction.paymentValidationSettingStoreFailure());
  }
}

function fetchSoftwareList() {
  return projectSettingApi.getSoftwareList();
}

function* accountingSoftwareWorker() {
  try {
    const response = yield call(fetchSoftwareList);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.getSoftwareListSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ProjectSettingAction.getSoftwareListFailure(message));
  }
}

function fetchSubSoftwareList(softwareId) {
  return projectSettingApi.getSubSoftwareList(softwareId);
}

function* accountingSubSoftwareWorker(action) {
  try {
    const softwareId = action.data && action.data.id;
    const response = yield call(fetchSubSoftwareList, softwareId);
    yield put(
      ProjectSettingAction.getSubSoftwareListSuccess(response.data.data)
    );
  } catch (error) {
    const message = SetMessage(error);
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.getSubSoftwareListFailure(message));
  }
}

function sharedContacts() {
  return projectSettingApi.sharedContacts();
}
function* sharedContactsWorker() {
  try {
    const response = yield call(sharedContacts);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(ProjectSettingAction.sharedContactsSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.sharedContactsFailure(error));
  }
}

function setUserState(userId, action) {
  return projectSettingApi.setUserState(userId, action);
}
function* setUserStateWorker(action) {
  try {
    const response = yield call(setUserState, action.userId, action.action);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(
      InitAction.getSuccess({ user_counts: response.data.user_counts })
    );
    yield put(ProjectSettingAction.setUserStateSuccess(response.data.data));
    // yield put(ProjectSettingAction.sharedContacts());
  } catch (error) {
    if (checkErrorMessagesExist(error)) {
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
      yield put(ProjectSettingAction.setUserStateFailure(error.response.data));
    }
    // dispatch a failure action to the store with the error
  }
}

function showUser(userId) {
  return projectSettingApi.showUser(userId);
}
function* showUserWorker(action) {
  try {
    const response = yield call(showUser, action.userId);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.showUserSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.showUserFailure());
  }
}

function updateUser(userId, data) {
  return projectSettingApi.updateUser(userId, data);
}
function* updateUserWorker(action) {
  try {
    const response = yield call(updateUser, action.userId, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectSettingAction.updateUserSuccess(response.data.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(ProjectSettingAction.updateUserFailure());
  }
}
